/** Reglas alineadas con el backend (`PasswordField` + `password_policy`). */
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 16;

/** Misma denylist que `api/common/password_policy.py` (controles, C1, ZW*, BOM, bidi). */
export const PASSWORD_DISALLOWED_CHARS_RE =
  /[\x00-\x08\x0b\x0c\x0e-\x1f\x7f\x80-\x9f\u00ad\u200b\u200c\u200d\u2060\ufeff\u202a-\u202e\u2066-\u2069]/;

export const passwordHasDisallowedCharacters = (raw: string): boolean =>
  PASSWORD_DISALLOWED_CHARS_RE.test(raw ?? '');

export type PasswordRuleStatus = {
  minLength: boolean;
  hasLetter: boolean;
  hasDigit: boolean;
  hasSpecial: boolean;
  withinMaxLength: boolean;
  noDisallowedChars: boolean;
};

export const evaluatePasswordRules = (raw: string): PasswordRuleStatus => {
  const value = raw ?? '';
  return {
    minLength: value.length >= PASSWORD_MIN_LENGTH,
    hasLetter: /[A-Za-z]/.test(value),
    hasDigit: /\d/.test(value),
    hasSpecial: /[^A-Za-z0-9]/.test(value),
    withinMaxLength: value.length <= PASSWORD_MAX_LENGTH,
    noDisallowedChars: !passwordHasDisallowedCharacters(value),
  };
};

export const passwordRulesAllSatisfied = (raw: string): boolean => {
  const s = evaluatePasswordRules(raw);
  return (
    s.minLength &&
    s.hasLetter &&
    s.hasDigit &&
    s.hasSpecial &&
    s.withinMaxLength &&
    s.noDisallowedChars
  );
};

export const getPasswordRulesErrorMessage = (raw: string): string | null => {
  const v = (raw ?? '').trim();
  if (!v) return 'Ingresa la contraseña.';
  if (v.length > PASSWORD_MAX_LENGTH) {
    return `La contraseña no puede superar ${PASSWORD_MAX_LENGTH} caracteres.`;
  }
  if (passwordHasDisallowedCharacters(v)) {
    return 'La contraseña no puede incluir caracteres de control, invisibles ni marcas bidireccionales.';
  }
  if (!passwordRulesAllSatisfied(v)) {
    return 'La contraseña debe tener al menos 10 caracteres, incluir letras, números y al menos un carácter especial.';
  }
  return null;
};
